<script setup lang="ts">
const { t: $t } = useI18n()

import type { UpdateOrCreateExternalWorkshopEmployeeUser } from '~/types'

const { openExternalWorkshopEmployeeCreateOrUpdatePopup: { data: popupData, close: closePopup } } = useGlobalOpeners()

const externalWorkshopEmployeeEmail = computed(() => popupData.value?.mode === 'update' ? popupData.value.email : undefined)

const { externalWorkshopEmployee } = useQuery()

const { data: externalWorkshopEmployeeUser, isFetching: isFetchingexternalWorkshopEmployeeUser } = externalWorkshopEmployee.byEmail(externalWorkshopEmployeeEmail)

const payload = computed((): UpdateOrCreateExternalWorkshopEmployeeUser | undefined => {
  if (!popupData.value) {
    return undefined
  }

  if (popupData.value.mode === 'create') {
    return {
      mode: 'create',
      data: {
        name: '',
        email: '',
      },
    }
  }

  if (!externalWorkshopEmployeeUser.value || isFetchingexternalWorkshopEmployeeUser.value) {
    return undefined
  }

  return {
    mode: 'update',
    data: externalWorkshopEmployeeUser.value,
  }
})

const { $trpc, queryClient, useMutation, makeTrpcErrorToast } = useMutationHelpers()
const notification = useNotification()

const create = useMutation({
  mutationFn: $trpc.externalWorkshopEmployee.create.mutate,
  onError: makeTrpcErrorToast(notification, { description: $t('defect.externalWorkshopEmployee.create.error.message') }),
  onSuccess: () => {
    queryClient.invalidateQueries({ queryKey: ['users'] })
    closePopup()
    notification.success({ title: $t('defect.externalWorkshopEmployee.create.success.message'), duration: 4500 })
  },
})

const update = useMutation({
  mutationFn: $trpc.externalWorkshopEmployee.update.mutate,
  onError: makeTrpcErrorToast(notification, { description: $t('defect.externalWorkshopEmployee.update.error.message') }),
  onSuccess: async () => {
    await queryClient.invalidateQueries({ queryKey: ['users'] })
    closePopup()
    notification.success({ title: $t('defect.externalWorkshopEmployee.update.success.message'), duration: 4500 })
  },
})

const submit = (payload: UpdateOrCreateExternalWorkshopEmployeeUser) => payload.mode === 'create' ? create.mutate(payload.data) : update.mutate(payload.data)
</script>

<template>
  <ThePopup
    v-if="popupData && payload"
    :show="true"
    :title="$t(`defect.externalWorkshopEmployee.${popupData.mode}.popup.title`)"
    @close="closePopup"
  >
    <ServiceExternalWorkshopEmployeeCreateOrEditForm :payload="payload" @submit="submit" />
  </ThePopup>
</template>
